import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';

const defaultTransition = { duration: 0.3, ease: 'easeInOut' };

interface IconProps {
	isHovered: boolean;
}

export function ShareIcon({ isHovered }: IconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<motion.circle
					cx='18'
					cy='5'
					r='3'
					variants={{
						normal: { scale: 1 },
						animate: { scale: 1.1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.circle
					cx='6'
					cy='12'
					r='3'
					variants={{
						normal: { scale: 1 },
						animate: { scale: 1.1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.circle
					cx='18'
					cy='19'
					r='3'
					variants={{
						normal: { scale: 1 },
						animate: { scale: 1.1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.line
					x1='8.59'
					y1='13.51'
					x2='15.42'
					y2='17.49'
					variants={{
						normal: { pathLength: 0 },
						animate: { pathLength: 1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
				<motion.line
					x1='15.41'
					y1='6.51'
					x2='8.59'
					y2='10.49'
					variants={{
						normal: { pathLength: 0 },
						animate: { pathLength: 1 },
					}}
					animate={controls}
					transition={defaultTransition}
				/>
			</svg>
		</div>
	);
}
